import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../contexts/AuthContext';
import { userService } from '../../../api/services';
import { translateApiError } from '../../../utils/apiError';

export default function KakaoCallback() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { socialLogin } = useAuth();
  // 인가 code 는 1회용이라 StrictMode 등으로 useEffect 가 두 번 실행되면
  // 두 번째 호출에서 401 이 떨어지고 catch 의 alert("로그인 실패") 가 잘못 뜸.
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return;
    handledRef.current = true;
    const run = async () => {
      try {
        const code = searchParams.get('code');
        if (!code) throw new Error('authorization code not found');

        const redirectUri = `${window.location.origin}/auth/kakao/callback`;
        await socialLogin('kakao', null, { code, redirect_uri: redirectUri });

        // OAuth 응답에 email/phone/name 일부 또는 전부 누락이면 보충 입력 페이지로
        let needsCompletion = false;
        try {
          const profile = await userService.getProfile();
          needsCompletion = !profile?.email?.trim() || !profile?.phone?.trim() || !profile?.name?.trim();
        } catch { /* getProfile 실패 시 통과 */ }

        if (needsCompletion) {
          navigate('/auth/complete-profile', { replace: true });
          return;
        }
        const redirectTo = sessionStorage.getItem('loginRedirect') || '/';
        sessionStorage.removeItem('loginRedirect');
        navigate(redirectTo, { replace: true });
      } catch (err) {
        if (err?.code === 'phone_already_registered') {
          const existingProvider = err?.response?.headers?.['x-existing-provider'];
          alert(existingProvider
            ? t('errors.phone_already_registered_with_provider', { provider: existingProvider })
            : t('errors.phone_already_registered'));
        } else {
          alert(translateApiError(err, t, 'auth.alert_kakao_login_failed'));
        }
        navigate('/login', { replace: true });
      }
    };
    run();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-mono-600">{t('auth.kakao_login')}...</p>
    </div>
  );
}
